import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useGroupActionsDialogs } from '../../../GroupActionsDialogs/GroupActionsDialogsProvider'

import { Icon, Menu } from '@percent/lemonade'
import type { GivingCampaignGroupPartnerDto } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'

export type GroupsActionsMenuProps = Readonly<{
  group: GivingCampaignGroupPartnerDto
}>

export function GroupsActionsMenu({ group }: GroupsActionsMenuProps) {
  const { t } = useTranslation()
  const { editGroup, archiveGroup } = useGroupActionsDialogs()

  const items = useMemo(
    () => [
      {
        key: 'edit',
        label: t('button.edit')
      },
      {
        key: 'delete',
        label: t('button.delete')
      }
    ],
    [t]
  )

  const onSelect = (key: string) => {
    switch (key) {
      case 'edit':
        editGroup({ id: group.id, name: group.name })
        break
      case 'delete':
        archiveGroup({ id: group.id, name: group.name })
        break
      default:
        break
    }
  }

  return <Menu title={<Icon name="menu-vertical" size={6} />} onSelect={onSelect} sections={[{ items }]} />
}
